import React, { useEffect, useRef, useState } from "react"
import {EyeFill} from "react-bootstrap-icons";
import { Link } from 'react-router-dom';
import { headers, url } from "../../utils/const"
import  Modal from 'react-bootstrap/Modal';
import { ModalBody, ModalHeader } from "react-bootstrap";
import imgLogo from "../../assets/logo-vlb.png";
import './player.css';
 const AdminPlayer = ()=>{
  const [ticketDetail, setTicketDetail] = useState(null);
  const [showModalTicketDetail, setShowModalTicketDetail] = useState(false);
    const [show, setShow] = useState(false);
    const retiroRef = useRef('');
    const [player, setPlayer] = useState({})
    const [ticket, setTicket] = useState([])
    const [dimenssion, setDimenssion] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setDimenssion({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dimenssion]);

    useEffect(()=>{
        (async()=>{
            const res = await fetch(`${url}/player/info-player`,{method:'get', headers: headers,credentials:'include'});
            const data = await res.json();
            console.log('DATA:',data)
            setTicket(()=> data.ticket);
            setPlayer(()=>data.player)
           // retiroRef.current?.value =data && data.player && data.player.credit? data.player.credit.balance.toFixed(2) : 0
        })()
    },[])
    const HiddenModalShowTicketDetail = () => {
    setShowModalTicketDetail(false);
  }
    const handleShow = ()=> setShow(true)
    const handleClose = ()=>setShow(false)
      /**Enter Para Pago */
  const EnterPay = (ticket,action) => {
        fetch(`${url}/ticket/pay`, {
          method: 'post',
          credentials:'include',
          headers: headers,
          body: JSON.stringify({ ticket, action })
        }).then(res => res.json())
          .then(data => {
            if (typeof (data) != 'string' && !data.msg) {
                alert(`Cobrado: $${data.amountToPay}`)
            } else if (typeof (data) == 'string') {

            } else if (data.msg && data.msg.includes('agado')) {
                alert('Jugada ya ha sido cobrada')
            }else{
              if(data.hasOwnProperty('msg') && data.msg.includes('petid')){
              }
            }
          })
      }
        /**Eliminar Ticket */
  const EliminarTicket = (ticket) => {
    fetch(`${url}/ticket/pay`, {
      method: 'post',
      headers: headers,
      credentials:'include',
      body: JSON.stringify({ ticket: ticket, action: 'Delete' })
    }).then(res => res.json())
      .then(data => {
        window.location.reload();
    })
  }
  const RetirarCredito =()=>{
    fetch(`${url}/player/solicitud-retiro`,{method:'post', headers: headers, body: JSON.stringify({player:player, amount:retiroRef.current.value}),credentials:'include'})
.then(res => res.json())
.then(data =>{
    setShow(false)
    window.location.reload();
})
}
  if (dimenssion.width < dimenssion.height) {
    return (
      <div className="fs-1 text-white">
        Favor colocar el dispositivo de forma Horizontal
      </div>
    );
  } else {
    return<div className=" container-fluid card admin-player">
        <div className="card-header col-12">
          <div className="col-12 row justify-content-center">
            <div className="col-3 fs-5">Codigo: {player.code}</div>
            <div className="col-3 fs-5">Credito: RD$. {player && player.credit? player.credit.balance.toFixed(2):''}</div>
            <div className="col-3"><button onClick={handleShow} className="btn btn-warning form-cotrol fs-5">Retirar Credito</button></div>
            </div>
            <div className="row col-12 pt-2">
            <div className="col fs-5"><Link to="https://dogs6.virsbet.com" className="btn btn-primary form-control fs-5">Perros de 6</Link></div>
            <div className="col fs-5"><Link to="https://orion.virsbet.com" className="btn btn-primary form-control fs-5">Perros de 8</Link></div>
            <div className="col fs-5"><Link to="https://este.virsbet.com" className="btn btn-primary form-control fs-5">Perros de 8 Tripleta</Link></div>
            <div className="col fs-5"><Link to="/machine" className="btn btn-primary form-control fs-5">Maquinita</Link></div>
            <div className="col fs-5"><Link to="https://casino.virsbet.com" className="btn btn-primary form-control fs-5" disabled>Casino</Link></div>
            <div className="col fs-5"><Link to="https://vlb.virsbet.com" className="btn btn-primary form-control fs-5" disabled>MLB Virtual</Link></div>
            </div>
        </div>
        <div className="card-body col-12 row justify-content-beetwen">
            <div className="col"><h6>Tickets de MLB Virtual Ultimas 24 Horas</h6></div>
        <div className="table table-responsive">
            <table className="table table-sm">
            <thead className="thead-dark">
                <tr className="tr-admin-player">
                    <th>Num</th>
                    <th>Ticket</th>
                    <th>Games</th>
                    <th>Apostado</th>
                    <th>Monto A Ganar</th>
                    <th>Ganador</th>
                    <th>Pagado</th>
                    <th>Ver</th>
                </tr>
            </thead>
            <tbody>
            {ticket? ticket.map((item, index)=><tr className="tr-admin-player" key={index}>
                    <td>{index+1}</td>
                    <td>{item.num}{item.games.active==true?<button className="btn btn-danger" onClick={()=>EliminarTicket(item.num)}>X</button>:''}</td>
                    <td>{item.games.num}</td>
                    <td>{item.amount}</td>
                    <td>{item.amountToWin.toLocaleString('EN-en',{maximumFractionDigits:2})}</td>
                    <td>{item.winner.state===true? 'Ganador':''}</td>
                    <td>{item.winner.state===true? item.winner.paid===true? 'Pagado':<button className="btn btn-success" onClick={()=>EnterPay(item.num,'pay')}>Cobrar</button>:''}</td>
                    <td><button className="btn btn-primary" onClick={()=>{setTicketDetail(()=>item); setShowModalTicketDetail(true)}}>Ver</button></td> 
                </tr>):<tr></tr>}
            </tbody>
            </table>
        </div>
        </div>
        <Modal show={show} size='sm' className='' >
                <ModalBody className="text-center">
                    
                <div className="col-12 m-1 p-1 bg-dark text-white">
                    <div className="col m-1 p-1"><label className="fs-3">Digite el monto a retirar:</label></div>
                    <div className="col m-1 p-1"><input type="number" className="form-control text-center fs-3" ref={retiroRef}></input></div>
                   
                    <div className="col m-1 p-1 row">
                        <div className="col m-1 p-1 row"><button className=" btn btn-warning form-control text-center fs-3" onClick={handleClose}>Cancelar</button></div>
                        <div className="col m-1 p-1 row"><button className=" btn btn-primary form-control text-center fs-3" onClick={RetirarCredito}>Solicitar Retiro</button></div>
                    </div>
                </div>
                </ModalBody>


        </Modal>
              <Modal show={showModalTicketDetail} onHide={HiddenModalShowTicketDetail} size="xl" className="bg-info">
                <Modal.Header closeButton>
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="">
                                {
                        <div className=''>
                          <div>
                            <div className="p-0 m-0">
                              <div className="col-12 d-flex justify-content-center p-0 m-0">
                                <div className="divLogoPrint align-midle">
                                  <img className="imgLogoPrint " src={imgLogo} />
                                </div>
                              </div>
                              <h6>{ticketDetail ? ticketDetail.point.name : ""}</h6>
                              <h6>
                                Ticket No.: 
                              </h6>
                              <h6>
                                Evento: {ticketDetail ? ticketDetail.games.code : ""}
                              </h6>
                              <h6>
                                Fecha:{" "}
                                {ticketDetail
                                  ? `${new Date(ticketDetail.date).toLocaleDateString(
                                      "es-ES"
                                    )} ${new Date(ticketDetail.date)
                                      .getHours()
                                      .toString()
                                      .padStart(2, "0")}:${new Date(ticketDetail.date)
                                      .getMinutes()
                                      .toString()
                                      .padStart(2, "0")}:${new Date(ticketDetail.date)
                                      .getSeconds()
                                      .toString()
                                      .padStart(2, "0")}`
                                  : ""}
                              </h6>
                            </div>
                            <table className="table table-sm col-12 p-0 m-0 lh-1">
                              <thead>
                                <tr>
                                  <th>Codigo</th>
                                  <th>Jugada</th>
                                  <th>Linea</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {ticketDetail
                                  ? ticketDetail.betted.map((z) => (
                                      <tr key={z.code} className="p-0 m-0">
                                        <td className="p-0 m-0">{z.code}</td>
                                        <td className="p-0 m-0">
                                          {z.betted}
                                        </td>
                                        <td className="p-0 m-0">
                                          {parseFloat(z.rate).toLocaleString(
                                            "en-EN",
                                            { maximumFractionDigits: 1 }
                                          )}
                                        </td>
                                        <td className="p-0 m-0">
                                          {z.winner == true ? "" : <span className="badge bg-danger">X</span>}
                                        </td>
                                      </tr>
                                    ))
                                  : ""}
                              </tbody>
                            </table>
                            <h3>
                              Total Apostado:{" "}
                              {ticketDetail ? ticketDetail.amount : ""}
                            </h3>
                                                <h3>
                              Total A Ganar:{" "}
                              {ticketDetail ? ticketDetail.amountToWin.toLocaleString("en-EN", { maximumFractionDigits: 2 }) : ""}
                            </h3>
                            <div>
                              {" "}
                              <h3>Copia</h3>
                            </div>
                          </div>
                        </div>
                      }
                </Modal.Body>
              </Modal>
    </div>
}
 }
export default AdminPlayer;